module.exports = __webpack_public_path__ + "img/empty.45595847.jpg";